import * as React from "react";
import { getHoverableTooltipsPreference } from "@1js/acui-common";
import type { AppTooltipProps } from "../Next";

export const useConvertTooltipContent = (
  props: AppTooltipProps,
  setVisible?: (visible: boolean) => void
): React.ReactElement => {
  const { content } = props;
  const hoverablePreference: boolean = getHoverableTooltipsPreference();
  return (
    <div
      onMouseEnter={() => {
        setVisible?.(hoverablePreference);
      }}
    >
      {typeof content === "function" ? content() : content}
    </div>
  );
};
